import { gql } from '@apollo/client';
import Fragments from './fragments';

export const INSURANCE_TYPES_QUERY = gql`
  query insuranceTypes {
    insuranceTypes {
      id
      name
    }
  }
`;

export const INSURERS_QUERY = gql`
  query insurersList {
    insurersList {
      id
      name
    }
  }
`;

export const GENERIC_ENTITY_FLOWS_QUERY = gql`
  query genericEntityFlowsDictionary($context: String!) {
    genericEntityFlowsDictionary(context: $context) {
      id
      name
      mainFlow
    }
  }
`;

export const GENERIC_ENTITY_BUSINESS_STATES_FLOW_QUERY = gql`
  query genericEntityBusinessStatesXFlow($flowId: ID!) {
    genericEntityBusinessStatesXFlow(flowId: $flowId) {
      id
      name
      isInitialState
      activeProduct
      editableYN
      deletePermitted
    }
  }
`;

export const FINANCIAL_PRODUCT_QUERY = gql`
  query financialProduct($productId: Int!) {
    financialProduct(productId: $productId) {
      ...financialProductItem
      leasingFinancialProduct {
        ...leasingFinancialProductItem
      }
      financialProductXBusinessFlow {
        ...financialProductXBusinessFlow
      }
      financialProductFilters {
        ...financialProductFilters
      }
      financialProductRules {
        ...financialProductRule
      }
      financialProductWarranties {
        ...financialProductWarranty
      }
      financialProductProperties {
        ...financialProductProperty
      }
      financialProductResidualValueGrids {
        ...financialProductResidualValueGrid
      }
      financialProductInsurers {
        ...financialProductInsurer
      }
      financialProductSeasonalityTemplates {
        ...financialSeasonalityTemplate
      }
    }
  }

  ${Fragments.financialProductItem}
  ${Fragments.leasingFinancialProductItem}
  ${Fragments.financialProductXBusinessFlow}
  ${Fragments.financialProductFilters}
  ${Fragments.financialProductRule}
  ${Fragments.financialProductWarranty}
  ${Fragments.financialProductProperty}
  ${Fragments.financialProductResidualValueGrid}
  ${Fragments.financialProductInsurer}
  ${Fragments.financialSeasonalityTemplate}
`;

export const COMPUTE_FINANCIAL_PRODUCT_NEXT_STATES = gql`
  query computeFinancialProductNextStates($stateId: Int!) {
    computeFinancialProductNextStates(stateId: $stateId) {
      stateId
      stateName
      activeProduct
    }
  }
`;

export const LEASING_PROMOTIONS_QUERY = gql`
  query leasingPromotions {
    leasingPromotions {
      promoId
      promoName
    }
  }
`;

export const DOCUMENT_LEASING_INCOME_SCHEMAS_QUERY = gql`
  query documentLeasingIncomeSchemas($documentId: Int) {
    documentLeasingIncomeSchemas(documentId: $documentId) {
      schemaId
      name
    }
  }
`;

export const LEASING_INTEREST_TYPES_QUERY = gql`
  query interestTypes {
    interestTypes {
      interestTypeId
      interestTypeName
    }
  }
`;

export const INSURANCE_CONVENTIONS_TYPES_QUERY = gql`
  query lightConventions {
    lightConventions {
      productId
      productName
      insTypeId
      insurerId
    }
  }
`;

export const FINANCIAL_PRODUCT_STATE_QUERY = gql`
  query financialProductState($productId: Int!) {
    financialProductState(productId: $productId) {
      productId
      currentStateId
      flowId
    }
  }
`;

export const FINANCIAL_PRODUCT_RESIDUAL_GRIDS_QUERY = gql`
  query residualValueGridDictionary {
    residualValueGridDictionary {
      id
      name
      maximumIncrease
      maximumDecrease
    }
  }
`;
